import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface QuestionMarkIconProps {
  color?: Color;
  size?: number;
}

const QuestionMarkIcon: React.FC<QuestionMarkIconProps> = ({ color, size }) => (
  <svg width={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 7.9989C10 7.9989 14.07 6.3519 14.626 9.0429C15.009 10.8979 11.626 13.2889 11.626 13.2889V14.4999M11.626 15.4999V16.4999V15.4999Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);

export default QuestionMarkIcon;
